import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Space, Spin,Input,Button } from 'antd';
import { LinkOutlined, ClearOutlined, DownOutlined } from '@ant-design/icons';
import axios from 'axios';
import { DiffChecker_URL } from '../../Components/Constant';

const { Option } = Select;

export default function ObjectAndFieldSelector({
    sourceSelection,
    destinationSelection,
    objectSelection,
    setObjectSelection,
    setExternalIdSelection,
    setParentfieldSelection,
    externalIdSelection,
    parentfieldSelection,
    parentCallback,
    titlefield,
    setTitleField,
    orderby,
    setOrderby,
    comparejourney,
    filterQuery,
    setFilterQuery
}) {
    const [sourceOrgId] = useState(
        sourceSelection
            ? sourceSelection?.Id
            : undefined
    );
    const [targetOrgId] = useState(
        destinationSelection
            ? destinationSelection?.Id
            : undefined
    );
    const [objectValue, setObjectValue] = useState('');
    const [objectList, setObjectList] = useState([]);
    const [externalIdValue, setExternalIdValue] = useState('');
    const [externalIdFields, setExternalIdFields] = useState([]);
    const [fields, setFields] = useState([]);
    const [isLoadingObjects, setIsLoadingObjects] = useState(false);
    const [isLoadingFields, setIsLoadingFields] = useState(false);
    const [customFields, setCustomFields] = useState(null);
    const [standardFields, setStandardFields] = useState(null);
    const [unavailableFields, setUnavailableFields] = useState([]);
    const [expandUnavailableFields, setExpandUnavailableFields] = useState(false);
    const [unavailableObjects, setUnavailableObjects] = useState([]);
    const [expandUnavailableObjects, setExpandUnavailableObjects] = useState(false);
    // const [comparejourney, setComparejourney] = useState(comparejourney || [])

    // useEffect(() => {
    //     if (objectSelection.length > 0) {
    //         getFields(objectSelection[0]);
    //     }
    // }, []);

    useEffect(() => {
        console.log('objectSelection changed:', objectSelection);
    if (objectSelection?.length > 0 && objectSelection[0]?.id) {
        getFields(objectSelection[0]);
    }
}, [objectSelection]);

    
    useEffect(() => {
        const fetchUnavailableObjects = async () => {
            console.log('Fetching unavailable objects for SourceOrg:', sourceOrgId, 'and TargetOrg:', targetOrgId);
            try {
                const response = await axios.post(`${DiffChecker_URL}/query/unavailableObjects`, {
                    'SourceUserId': sourceOrgId,
                    'TargetUserId': targetOrgId,
                });
                console.log('Unavailable objects response:', response.data);
                return response.data.unavailableObjects || [];
            } catch(error){
                console.error('Error fetching unavailable objects:', error);
                return [];
            }
        };

        const fetchObjects = async (unavailableObjList) => {
            setIsLoadingObjects(true);
            try {
                const response = await axios.post(DiffChecker_URL + '/query/Objects', {
                    "UserId": sourceOrgId 
                });
                console.log('Fetched object list:', response.data);
                const unavailableObjectNames = unavailableObjList.map(obj => obj?.label || obj?.value || obj);
                console.log('Unavailable Object Names:', unavailableObjectNames);
                setObjectList(response.data.filter(obj => !unavailableObjectNames.includes(obj)));
            } catch (error) {
                console.error('Error fetching object list:', error);
            } finally {
                setIsLoadingObjects(false);
            }
        };

        const initializeFetch = async () => {
            console.log('SourceOrgId or TargetOrgId changed:', sourceOrgId, targetOrgId);
            const unavailableObjList = await fetchUnavailableObjects();
            setUnavailableObjects(unavailableObjList);
            await fetchObjects(unavailableObjList);
        };

        initializeFetch();
    }, [sourceOrgId]);

    const getFields = async (selectedData) => {
        setIsLoadingFields(true);
        try {
            console.log('Compare Journey Object Config:', comparejourney);
            console.log('Fetching fields for object:', selectedData.id, comparejourney?.objectConfig?.object);
            const response = await axios.post(`${DiffChecker_URL}/query/fields`, {
                'UserId': sourceOrgId ,
                'ObjectName': selectedData.id || comparejourney?.objectConfig?.object
            });
            
            // Fetch unavailable fields first (comparing source with target)
            let fetchedUnavailableFields = [];
            try {
                console.log('Compare Journey:', comparejourney);
                console.log('Selected Data:', selectedData.id);
                console.log('Source Org ID:', sourceOrgId);
                console.log('Target Org ID:', targetOrgId);
                const unavailableResponse = await axios.post(`${DiffChecker_URL}/query/unavailableFields`, {
                    'SourceUserId': sourceOrgId,
                    'TargetUserId': targetOrgId,
                    'ObjectName': selectedData.id || comparejourney?.objectConfig?.object,
                });
                console.log('Unavailable fields response:', unavailableResponse.data);
                fetchedUnavailableFields = unavailableResponse.data.unavailableFields || [];
                setUnavailableFields(fetchedUnavailableFields);
            } catch (error) {
                console.error('Error fetching unavailable fields:', error);
                setUnavailableFields([]);
            }
            
            const unavailableFieldNames = fetchedUnavailableFields.map(uf => uf?.label || uf?.value || uf);
            console.log('Unavailable Field Names:', unavailableFieldNames);
            const fieldsOptions = response.data.fields.filter(f => f !== 'Id' && !unavailableFieldNames.includes(f));
            const customFieldsOption = 'All Custom Fields';
            const standardFieldsOption = 'All Standard Fields';
            
            setCustomFields(response.data.customFields.filter(f => f !== 'Id' && !unavailableFieldNames.includes(f)));
            setStandardFields(response.data.standardFields.filter(f => f !== 'Id' ));
            setExternalIdFields(response.data.externalIdFields.filter(f => f !== 'Id' && !unavailableFieldNames.includes(f)));
            setFields([customFieldsOption, standardFieldsOption, ...fieldsOptions]);
        } catch (error) {
            console.error('Error fetching fields:', error);
        } finally {
            setIsLoadingFields(false);
        }
    };

      const handleRemoveAll = () => {
        setParentfieldSelection([]);
        parentCallback(objectSelection, externalIdSelection, titlefield, []);
    };


    return (
        <div style={{ width: '100%' }}>

                
             <Row gutter={16}>
                {/* Object Select */}
                <Col span={8}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ marginBottom: 4 }}>Object</span>
                        {isLoadingObjects ? (
                            <Spin />
                        ) : (
                            <Select
                                virtual={false}
                                showSearch
                                placeholder="Select Object"
                                value={objectSelection}
                                onChange={(value, option) => {
                                    setObjectValue(value);
                                    const newSelection = [{ label: option.label, id: value }];
                                    setObjectSelection(newSelection);
                                    getFields({ id: value });
                                    setExternalIdSelection(null);
                                    setExternalIdValue('');
                                    setParentfieldSelection([]);
                                    setTitleField(null);
                                    // setOrderby('ASC');
                                    setFilterQuery('');
                                    parentCallback(newSelection, null, null, [], "");
                                }}
                                filterOption={(input, option) =>
                                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                }
                                style={{ width: '100%' }}
                                options={objectList.map(obj => ({
                                    label: obj,
                                    value: obj,
                                }))}
                            />

                        )}
                    </div>
                </Col>

                {/* External ID Select */}
                <Col span={8}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ marginBottom: 4 }}>External Id</span>
                        {isLoadingFields ? (
                            <Spin />
                        ) : (
                            <Select
                                mode="multiple"
                                virtual={false}
                                showSearch
                                placeholder="Select External Id"
                                // value={externalIdSelection?.map(e => e.id) || []}
                                value={
                                    Array.isArray(externalIdSelection)
                                        ? externalIdSelection.map(e => e?.id || e)
                                        : []
                                }
                                onChange={(values) => {
                                    const newSelection = values.map(v => ({
                                        label: v,
                                        id: v
                                    }));
  
                                    setExternalIdSelection(newSelection);

                                    parentCallback(
                                        objectSelection,
                                        newSelection,
                                        titlefield,
                                        parentfieldSelection
                                    );
                                }}
                                style={{ width: '100%' }}
                            >
                                {externalIdFields?.map(f => (
                                    <Option key={f} value={f}>
                                        <Space><LinkOutlined />{f}</Space>
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </div>
                </Col>

                {/* Title field selection */}
                <Col span={8}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ marginBottom: 4 }}>Title Field</span>
                        {isLoadingFields ? (
                            <Spin />
                        ) : (
                            <Select
                                virtual={false}
                                showSearch
                                placeholder="Select Title Field"
                                value={titlefield?.id || titlefield || undefined} // use primitive value for Select
                                onChange={(value) => {
                                    const selected = fields.find(f => f === value);
                                    const newSelection = { label: selected, id: value }; // object for state only
                                    setTitleField(newSelection);
                                    parentCallback(objectSelection, externalIdSelection, newSelection, parentfieldSelection);
                                }}
                                style={{ width: '100%' }}
                            >
                                {[...new Set(fields)]
                                    .filter(f => f !== "All Custom Fields" && f !== "All Standard Fields" && f !== 'Id')
                                    .map(f => (
                                        <Option key={f} value={f}>
                                            <Space><LinkOutlined />{f}</Space>
                                        </Option>
                                    ))}
                            </Select>
                        )}
                    </div>
                </Col>


            </Row>

            <Row gutter={16}>
                {/* {Order by Selection} */}
                <Col span={8}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ marginBottom: 4 }}>Order By</span>
                        {isLoadingFields ? (
                            <Spin />
                        ) : (
                            <Select
                                virtual={false}
                                placeholder="Select Order"
                                value={orderby || undefined}
                                onChange={(value) => {
                                    setOrderby(value);
                                    console.log('orderby selected:', value);
                                    parentCallback(objectSelection, externalIdSelection, titlefield, parentfieldSelection, value);
                                }}
                                style={{ width: '100%' }}
                            >
                                <Option value="ASC">ASC (Ascending)</Option>
                                <Option value="DESC">DESC (Descending)</Option>
                            </Select>
                        )}
                    </div>
                </Col> 
            </Row>

             <Row gutter={16} style={{ marginBottom: 10 ,marginTop:10}}>
                <Col span={24}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ marginBottom: 4,width:'100%' }}>Filter Query</span>
                        <Input
                            placeholder="Enter filter query (optional)"
                            defaultValue={filterQuery || comparejourney?.filterquery}
                            addonBefore="WHERE"
                            onChange={(e) => setFilterQuery(e.target.value)}
                            
                        />
                    </div>
                </Col>
            </Row>

            {/* Fields Multi-Select */}
            <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={24}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                            <span>Fields</span>
                            <Button onClick={handleRemoveAll} icon={<ClearOutlined />}>
                                Remove All
                            </Button>
                        </div>
                        <Select
                            mode="multiple"
                            showSearch
                            virtual={false}
                            placeholder="Search Fields"
                            value={parentfieldSelection?.map(f => f?.value || f?.label || f) || []} // handle both object and primitive
                            onChange={(values) => {
                                let selectedFields = [];
                                if (values.includes('All Custom Fields')) {
                                    selectedFields = customFields.map(f => ({ label: f, value: f }));
                                } else if (values.includes('All Standard Fields')) {
                                    selectedFields = standardFields.map(f => ({ label: f, value: f }));
                                } else {
                                    selectedFields = values.map(v => ({ label: v, value: v }));
                                }
                                setParentfieldSelection(selectedFields);
                                parentCallback(objectSelection, externalIdSelection, titlefield, selectedFields);
                            }}
                            style={{ width: '100%' }}
                            maxTagCount={10} // ✅ show only 10 tags, rest hidden
                            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`} // ✅ custom placeholder
                            dropdownStyle={{ maxHeight: 300, overflowY: 'auto' }} // ✅ internal scrolling
                        >
                            {[...new Set(fields)]
                            .filter(f => f !== 'Id')?.map(f => (
                                <Option key={f} value={f}>
                                    <Space><LinkOutlined />{f}</Space>
                                </Option>
                            ))}
                        </Select>
                    </div>
                </Col>
            </Row>

            {/* Unavailable Fields Display */}
            {unavailableObjects && unavailableObjects.length > 0 && (
            <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={24}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: 8 }}>
                    <span>Unavailable Objects (Not in Destination)</span>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, maxHeight: 250, overflowY: 'auto', paddingRight: 8 }}>
                    {(expandUnavailableObjects
                        ? unavailableObjects
                        : unavailableObjects.slice(0, 4)
                    ).map(f => (
                        <div
                        key={f?.value || f}
                        style={{
                            padding: '1px 8px',
                            backgroundColor: '#fff1f0',
                            border: '1px solid #ff4d4f',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 3,
                            fontSize: '11px',
                            color: '#ff4d4f',
                            fontWeight: '500',
                            whiteSpace: 'nowrap'
                        }}
                        >
                        <LinkOutlined style={{ fontSize: '9px' }} />
                        {f?.label || f}
                        </div>
                    ))}

                    {/* +X more tile */}
                    {!expandUnavailableObjects && unavailableObjects.length > 4 && (
                        <div
                        onClick={() => setExpandUnavailableObjects(true)}
                        style={{
                            padding: '1px 8px',
                            backgroundColor: '#f5f5f5',
                            border: '1px dashed #d9d9d9',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '11px',
                            color: '#666',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                        >
                        +{unavailableObjects.length - 4} more
                        </div>
                    )}

                    {/* Collapse tile */}
                    {expandUnavailableObjects && unavailableObjects.length > 4 && (
                        <div
                        onClick={() => setExpandUnavailableObjects(false)}
                        style={{
                            padding: '1px 8px',
                            backgroundColor: '#fafafa',
                            border: '1px dashed #d9d9d9',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '11px',
                            color: '#999',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                        >
                        Collapse
                        </div>
                    )}
                    </div>
                </div>
                </Col>
            </Row>
            )}


            {/* Unavailable Fields Display */}
            {unavailableFields && unavailableFields.length > 0 && (
            <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={24}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: 8 }}>
                    <span>Unavailable Fields (Not in Destination)</span>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, maxHeight: 250, overflowY: 'auto', paddingRight: 8 }}>
                    {(expandUnavailableFields
                        ? unavailableFields
                        : unavailableFields.slice(0, 4)
                    ).map(f => (
                        <div
                        key={f?.value || f}
                        style={{
                            padding: '1px 8px',
                            backgroundColor: '#fff1f0',
                            border: '1px solid #ff4d4f',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 3,
                            fontSize: '11px',
                            color: '#ff4d4f',
                            fontWeight: '500',
                            whiteSpace: 'nowrap'
                        }}
                        >
                        <LinkOutlined style={{ fontSize: '9px' }} />
                        {f?.label || f}
                        </div>
                    ))}

                    {/* +X more tile */}
                    {!expandUnavailableFields && unavailableFields.length > 4 && (
                        <div
                        onClick={() => setExpandUnavailableFields(true)}
                        style={{
                            padding: '1px 8px',
                            backgroundColor: '#f5f5f5',
                            border: '1px dashed #d9d9d9',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '11px',
                            color: '#666',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                        >
                        +{unavailableFields.length - 4} more
                        </div>
                    )}

                    {/* Collapse tile */}
                    {expandUnavailableFields && unavailableFields.length > 4 && (
                        <div
                        onClick={() => setExpandUnavailableFields(false)}
                        style={{
                            padding: '1px 8px',
                            backgroundColor: '#fafafa',
                            border: '1px dashed #d9d9d9',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '11px',
                            color: '#999',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                        >
                        Collapse
                        </div>
                    )}
                    </div>
                </div>
                </Col>
            </Row>
            )}

        </div>
    );
}